import emptyFees from '@/assets/lotties/empty_state.json';
import loadingError from '@/assets/lotties/payment_failure.json';

export const EVENTS = {
  FEE: {
    LIST_ALL: {
      REFRESH: 'FEE_LIST_ALL_REFRESH',
      REFRESHING: 'FEE_LIST_ALL_REFRESHING',
      REFRESHED: 'FEE_LIST_ALL_REFRESHED',
      REFRESH_ERROR: 'FEE_LIST_ALL_REFRESH_ERROR'
    },
    CREATE_OR_UPDATE: {
      SHOW: 'FEE_CREATE_OR_UPDATE_SHOW'
    },
    SUBMIT: 'FEE_SUBMIT',
    UPDATED: 'FEE_UPDATED'
  }
};

export const ENDPOINTS = {
  FEE: {
    GET_LIST:
      'https://apis.1xpay.co/fee-ms/getFees/{lacasaeBettingServiceName}/{lacasaeBettingServiceName}',
    UPDATE: 'https://apis.1xpay.co/fee-ms/setFee'
  }
};

export const FEE = {
  COUNTRIES: {
    BJ: { name: 'Bénin', flag: '🇧🇯' },
    BF: { name: 'Burkina Faso', flag: '🇧🇫' },
    CI: { name: "Côte d'Ivoire", flag: '🇨🇮' },
    ML: { name: 'Mali', flag: '🇲🇱' },
    GA: { name: 'Gabon', flag: '🇬🇦' },
    NE: { name: 'Niger', flag: '🇳🇪' },
    SN: { name: 'Sénégal', flag: '🇸🇳' },
    TG: { name: 'Togo', flag: '🇹🇬' }
  },

  OPERATIONS: {
    withdrawal1xBet: { label: 'Retrait 1xBet', category: 'betting' },
    fund1xBet: { label: 'Dépôt 1xBet', category: 'betting' },
    withdrawalBetWinner: { label: 'Retrait BetWinner', category: 'betting' },
    fundBetWinner: { label: 'Dépôt BetWinner', category: 'betting' },
    withdrawal1Win: { label: 'Retrait 1Win', category: 'betting' },
    fund1Win: { label: 'Dépôt 1Win', category: 'betting' },
    withdrawalEightStarz: { label: 'Retrait EightStarz', category: 'betting' },
    fundEightStarz: { label: 'Dépôt EightStarz', category: 'betting' },
    withdrawalMelbet: { label: 'Retrait Melbet', category: 'betting' },
    fundMelbet: { label: 'Dépôt Melbet', category: 'betting' },
    withdrawalAffiliation: {
      label: 'Retrait Affiliation',
      category: 'affiliation'
    },
    buyUsdt: { label: 'Achat USDT', category: 'crypto' },
    sellUsdt: { label: 'Vente USDT', category: 'crypto' },
    buyGiftCard: { label: 'Achat Carte Cadeau', category: 'giftcard' },
    sellGiftCard: { label: 'Vente Carte Cadeau', category: 'giftcard' },
    fundWallet: { label: 'Dépôt sur Portefeuille', category: 'wallet' },
    withdrawalWallet: { label: 'Retrait Portefeuille', category: 'wallet' },
    platformSubscription: { label: 'Abonnements', category: 'platform' }
  },

  CATEGORIES: {
    betting: { label: 'Paris Sportifs', icon: '⚽' },
    affiliation: { label: 'Affiliation', icon: '👥' },
    crypto: { label: 'Crypto', icon: '₿' },
    giftcard: { label: 'Cartes Cadeaux', icon: '🎁' },
    wallet: { label: 'Portefeuille', icon: '💼' },
    platform: { label: 'Abonnements', icon: '🔧' }
  },

  FEE_TYPES: {
    serviceFee: {
      label: 'Frais de Service',
      description: 'Frais total appliqués par le service',
      color: 'blue'
    },
    profitFee: {
      label: 'Marge',
      description: 'Marge de la plateforme',
      color: 'green'
    },
    processorFee: {
      label: 'Frais Processeur',
      description: 'Frais du processeur de paiement',
      color: 'orange'
    },
    discountFee: {
      label: 'Remise',
      description: 'Remise appliquée',
      color: 'purple'
    },
    bonusFee: { label: 'Bonus', description: 'Bonus ajouté', color: 'yellow' },
    affiliationBonus: {
      label: 'Bonus Affiliation',
      description: 'Bonus affiliation',
      color: 'pink'
    }
  },

  LOTTIES: {
    EMPTY: emptyFees,
    LOADING_ERROR: loadingError
  }
};
